<script>
	import {Form} from '../../../../helpers/Form/Form'

	export default {
		props: {
			companyId: Number
		},
		data() {
			return {
				complete: false,
				form: new Form({
					phone: null
				})
			}
		},
		mounted() {
			this.$bus.$on('item.promotion', (payload) => {
				$(this.$refs.modal).modal('show')
			})

			$(this.$refs.modal).on('hide.bs.modal', () => {
				this.$set(this, 'complete', false)
				this.form.reset()
			})
		},
		methods: {
			async onSubmit() {
				await this.form
					.post(route('companies.promotion_request', this.companyId))
					.then(response => {
						this.$set(this, 'complete', true)
					}).catch(error => {

					})
			}
		}
	}
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/company/dashboard/partials/PromotionModal.vue